import { RootState } from '@/store/types';
import { GetterTree } from 'vuex';
import { ModalState } from './types';

export const getters: GetterTree<ModalState, RootState> = {};
